const notifications = {
  search_contacts: 'Phone / Email',
  report_type: 'Report type',
  failed_payments_report: 'Failed payments report',
  paid_payments_report: 'Paid payments report',
  failed_recurrings_report: 'Failed subscriptions report',
};

export default notifications;
